import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import SectionHeader from "../../components/sectionHeader/sectionHeader";
import { cardData } from "./data/data.js";
import { getApiInstance } from "../../utils/api";

import "./dashboard.scss";

export default function Dashboard() {
    const [currentUser, setCurrentUser] = useState(null);
    useEffect(() => {
        fetchCurrentUser();
    }, []);

    const fetchCurrentUser = async () => {
        const api = getApiInstance();
        try {
            const response = await api.get(
                "/api/Usuario/GetCurrentUserWithEmpresa"
            );
            setCurrentUser(response.data);
        } catch (error) {
            console.error("Error al obtener usuario actual:", error);
        }
    };

    const filteredCardData = cardData.filter((card) => {
        if (!currentUser) return true;

        if (currentUser.codTipoEmpresa === 4 && card.link !== "usuarios") {
            return false;
        }

        if (
            currentUser.codTipoEmpresa === 2 &&
            (card.link === "muebles" || card.link === "maestro-dotaciones")
        ) {
            return false;
        }

        if (
            currentUser.codTipoEmpresa === 3 &&
            !["solicitudes-tarifas", "usuarios", "presupuestos"].includes(card.link)
        ) {
            return false;
        }

        if (
            currentUser.codTipoEmpresa !== 3 &&
            card.link === "solicitudes-tarifas"
        ) {
            return false;
        }

        return true;
    });

    return (
        <div className="dashboard">
            <SectionHeader
                title="Panel de Administrador"
                subtitle="Maneja y gestiona usuarios, muebles, versiones, informes, comentarios y más"
            />
            <div className="dashboard__cards">
                {filteredCardData.map((card) => (
                    <Link
                        key={card.id}
                        to={`/admin/${card.link}`}
                        className="dashboard__cards__card"
                    >
                        <div className="dashboard__cards__card__icon">
                            {card.icon}
                        </div>
                        <div className="dashboard__cards__card__title">
                            {card.title}
                        </div>
                    </Link>
                ))}
            </div>
        </div>
    );
}
